import React from 'react'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { CoachAvatar } from '@src/components/Avatar/CoachAvatar'
import { Button, Text } from '@src/components/base'
import { AllCoachProfilesQuery } from '@src/graphql/fetchAllCoachProfiles.generated'
import { RootStackParamList } from '@src/navigation/types'

interface CoachInfoProps {
  coachProfile: AllCoachProfilesQuery['allCoachProfiles']['coachProfiles'][0]
}

export const CoachInfo = ({ coachProfile }: CoachInfoProps) => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation<StackNavigationProp<RootStackParamList>>()

  const handleShowBio = () => {
    const { bio, credentials, fullName, specialties, photo } = coachProfile

    if (!bio) {
      return
    }

    navigation.navigate('CoachInfoModal', {
      variant: 'bio',
      photo,
      fullName,
      credentials,
      bio,
      specialties,
    })
  }

  return (
    <View style={styles.infoContainer}>
      <CoachAvatar photo={coachProfile.photo} style={styles.coachPhoto} />
      <View>
        <Text type="regular" style={styles.coachName}>
          {coachProfile.fullName}
        </Text>
        <Text type="regular" style={styles.credentials}>
          {coachProfile.credentials}
        </Text>
      </View>
      {coachProfile.bio && (
        <Button
          type="outline"
          accessibilityLabel="Show Bio"
          size="small"
          style={styles.button}
          onPress={handleShowBio}
        >
          Show Bio
        </Button>
      )}
    </View>
  )
}

const themedStyles = StyleService.create({
  infoContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
  },
  coachName: {
    fontWeight: '700',
    maxWidth: 150,
    ellipsizeMode: 'tail',
    numberOfLines: 1,
  },
  coachPhoto: {
    width: 48,
    height: 48,
    borderRadius: 52,
  },
  credentials: {
    color: 'theme.text.secondary',
    fontSize: 13,
  },
  button: {
    marginLeft: 'auto',
  },
})
